export let ProcessMonitor = {
    path: 'process-monitoring',
    name: 'process-monitoring',
    meta: {
        roleCode: '013',
    },
    component: () =>
        import(
            /* webpackChunkName: "process-monitoring" */
            '@/views/back-stage/processmonitor/process-monitoring.vue'
        ),
    children: [
        {
            path: 'approval-time-length',
            name: 'approval-time-length',
            component: () =>
                import(
                    /* webpackChunkName: "approval-time-length" */
                    '@/views/back-stage/processmonitor/approval-time-length.vue'
                ),
        },
        {
            path: 'department-volume',
            name: 'department-volume',
            component: () =>
                import(
                    /* webpackChunkName: "department-volume" */
                    '@/views/back-stage/processmonitor/department-volume.vue'
                ),
        },
        {
            path: 'process-adjustment',
            name: 'process-adjustment',
            component: () =>
                import(
                    /* webpackChunkName: "process-adjustment" */
                    '@/views/back-stage/processmonitor/process-adjustment.vue'
                ),
        },
        {
            path: '*',
            redirect: 'approval-time-length',
        },
    ],
};
